var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/trophy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 5.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9868421,22 L16.9868421,20.3333515 C16.9803564,20.0176316 16.7827809,19.7418946 16.4967368,19.6493589 C14.4549423,18.9686995 13.1013932,16.9246082 13.1973684,14.6667465 C13.1973684,9.61480152 19.0723158,15.9267328 19.2605263,0.753564675 C19.2461122,0.325679399 18.9081352,-0.0102598478 18.5026316,0.000239543979 L4.86052632,0.000239543979 C4.4550227,-0.0102598478 4.11704567,0.325679399 4.10263158,0.753564675 C4.28957895,15.9267328 10.1657895,9.61480152 10.1657895,14.6667465 C10.2637846,16.9272808 8.90857707,18.9744998 6.86389474,19.6546922 C6.58034248,19.7471902 6.38420511,20.0201931 6.37631579,20.3333515 L6.37631579,22 L16.9868421,22 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89193923,2.03385702 L0.709686251,2.03385702 C0.514373563,2.02789948 0.325827565,2.1095014 0.190889046,2.25839029 C0.055950526,2.40727918 -0.0127165057,2.60948179 0.00194701228,2.81476458 C0.170517631,4.68433321 0.997929141,9.25725198 5.05263158,9.15014833",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4529892,2.03385702 L22.6690917,2.03385702 C22.8605924,2.02864398 23.0451869,2.11062689 23.1771,2.25947599 C23.3090132,2.40832508 23.3758907,2.61009969 23.3611484,2.81476458 C23.1941439,4.69789063 22.3705079,9.32232761 18.3105263,9.14608111",
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.e4811a3db693d71d5c1eedd4310b0ef0.svg";
export { ForwardRef as ReactComponent };